export const CURRENT_TAX_YEAR = 2025

export const COVID_RELIEF_GRANT_YEARS = [2022, 2021]
export const COVID_WORK_FROM_HOME_ALLOWANCE_YEARS = [2022, 2021]

export const TAX_YEAR_START_MONTH = '04'
export const TAX_YEAR_START_DAY = '06'
export const TAX_YEAR_END_MONTH = TAX_YEAR_START_MONTH
export const TAX_YEAR_END_DAY = '05'

export const TAX_YEARS = {
    2025: '2024/25',
    2024: '2023/24',
    2023: '2022/23',
    2022: '2021/22',
    2021: '2020/21',
    2020: '2019/20',
    2019: '2018/19',
    2018: '2017/18',
    2017: '2016/17',
    2016: '2015/16',
    2015: '2014/15',
    2014: '2013/14',
    2013: '2012/13',
}

export const CIS_SCHEME_START_YEAR = 1972
